import React from 'react';
import PropTypes from 'prop-types';

export const MissingMatch = ({ width , height , ...props }) => (
  <svg
    data-icon='missing-match'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M14.4 20 13 18.6l2.6-2.6-2.6-2.6 1.4-1.4 2.6 2.6 2.6-2.6 1.4 1.4-2.6 2.6 2.6 2.6-1.4 1.4-2.6-2.6-2.6 2.6Zm1.975-9-3.55-3.55 1.4-1.4 2.125 2.125 4.25-4.25L22 5.35 16.375 11ZM2 17v-2h9v2H2Zm0-8V7h9v2H2Z'
    />
  </svg>
);

MissingMatch.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

MissingMatch.defaultProps = {
  width: 24,
  height: 24,
};
